import React, { Component } from 'react';
import NumberFormat from 'react-number-format';




export default class PrintTable extends React.Component {



constructor() {
  super();    
  this.state = {
    headersParams: []
  };
}



// componentDidMount() {

//   this.setState({ showData: this.state.showData.concat(this.props.body.slice(0, 5000)), zaladowano: 5000});

//   if(this.props.body.length > 5000) {

//     this.loadMoreData()

//   }

// }



// loadMoreData = () => {

//   let zaladowano = this.state.zaladowano;

//   let zaladujDo = zaladowano + 5000;

//   setTimeout(() => {

//     this.setState({

//       showData: this.state.showData.concat(this.props.body.slice(zaladowano, zaladujDo)),

//       zaladowano: zaladujDo

//     });

//     if(this.props.body.length > zaladujDo) {

//       this.loadMoreData()

//     }

//   }, 1500);

// };


componentDidMount() {
  this.props.headers.map((data, idx) => {
    this.addToHeaders(data.typ)
  });
}

addToHeaders = (value) => {
  this.setState(prevState => ({
    headersParams: [...prevState.headersParams, value]
  }));
}




render() {



return (

<React.Fragment>

<div className="d-flex flex-column">

{this.props.header ? (this.props.header.map(items => <b>{items}</b>)) : null }

{this.props.headerExt ? (this.props.headerExt.map(items => <p>{items}</p>)) : null }

<table className="mt-2 mb-2 table table-bordered">

<thead>

  <tr key="01">

    {this.props.headers.map((data, idx) => {

      return <th key={idx}>{data.name}</th>

    })}

  </tr>

</thead>

<tbody>

  {this.props.body.map((data, idx) => {

    return (<><tr key={idx} id={idx}>

      {data.map((ins, idx) => {
        return <td key={idx} style={this.state.headersParams[idx] == 'varchar' || this.state.headersParams[idx] == 'integer' ? { textAlign: 'left'} : { textAlign: 'right'} }>
          {this.state.headersParams[idx] == 'varchar' || this.state.headersParams[idx] == 'integer' ? ins : (<>{this.state.headersParams[idx] == 'datetime' || this.state.headersParams[idx] == 'timestamp' ? (this.parsedDate(ins)) : (<NumberFormat value={ins} thousandSeparator={' '} style={{ whiteSpace: 'nowrap' }} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} />)}</>)}
        </td>

      })}

    </tr></>)

  })}

</tbody>

</table>

{this.props.footer ? (this.props.footer.map(items => <p>{items}</p>)) : null }

</div>



</React.Fragment>

);

}

}

